import { action } from "satcheljs";
import type { SearchScenarioId } from "owa-search-store";
import { addDatapointConfig } from "owa-analytics-actions";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

export interface ON_SEARCH_INPUT_FOCUSEDActionMessage {
    scenarioId: SearchScenarioId;
}
export const onSearchInputFocused: (scenarioId: SearchScenarioId) => ON_SEARCH_INPUT_FOCUSEDActionMessage = action("ON_SEARCH_INPUT_FOCUSED", (scenarioId: SearchScenarioId): ON_SEARCH_INPUT_FOCUSEDActionMessage => addDatapointConfig("ON_SEARCH_INPUT_FOCUSED", getModuleContextMailboxInfo(), undefined, {
    scenarioId,
}));
